import React, { useEffect, useState } from 'react';
import {Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap"
import { Button } from 'react-bootstrap';
import { Progress } from 'antd';
import { getScenarioGroupProgress, stopScenarioGroupingProcess } from '../UserFunctions'
import PropTypes from "prop-types";


const ProgressBar = (props) => {
    const [scenarioGroupProgress,setScenarioGroupProgress] = useState(false)
    const [show,setShow] = useState(false)
    const [timeoutVal, setTimeoutVal] = useState(1000)
    const [componentStatus, setComponentStatus] = useState(false);
    const [progressInfo, setProgressInfo] = useState({
                                                status:"None",
                                                completed_scenario_group:0,
                                                total_scenario_group:0,
                                                percentageCompleted:0
                                            });
    console.log(props.popup)

    useEffect(() => {
        const timeout = setTimeout(() => {
            getScenarioGroupProgress('/get_scenario_grouping_progress').then(res => {             
                console.log(res.status)
                if (res.status === "In progress"){
                    setScenarioGroupProgress(true)
                    let percentage = res.completed_scenario_group/res.total_scenario_group*100;
                    setProgressInfo({
                        status:res.status,
                        completed_scenario_group:res.completed_scenario_group,
                        total_scenario_group:res.total_scenario_group,
                        percentageCompleted:percentage 
                    })
                    setShow(!show)
                    setTimeoutVal(1000)
                }
                else{
                    setProgressInfo({
                        status:res.status,
                        completed_scenario_group:res.completed_scenario_group,
                        total_scenario_group:res.total_scenario_group,
                        percentageCompleted:0 
                    })
                    setTimeoutVal(1000)
                    setScenarioGroupProgress(false)
                }
                if (props.popup){
                    setShow(!show)
                }
            })
        }, timeoutVal)
        return () => clearInterval(timeout);        
    }, [show,props.popup,scenarioGroupProgress]);

    const onComponentStatus = () => {
        setComponentStatus(!componentStatus);
    };

    const handleStopAndCleanCache = () => {
        stopScenarioGroupingProcess('stop_and_clear_scenario_grouping_process').then(res => {
            if (res.status_message === "Stopped Succesfully") {
                props.loading()
                alert("Scenario grouping process is stopped and cache is cleaned")
            }
        })
    }
    
    return scenarioGroupProgress ?(
        <Modal isOpen={true}>
            <ModalHeader>
                <Button
                    type='submit'
                    style={{
                        backgroundColor: '#757AF7',
                        color: '#FFFFFF'
                    }}
                    onClick = {handleStopAndCleanCache} 
                    data-test = "clickComponent"
                >
                    Stop and Clean Cache
                </Button>
            </ModalHeader>
            <ModalBody>
                <h3>Scenario Group Generation</h3>
                <Progress
                    strokeColor={{
                    from: '#757AF7',
                    to: '#B0FF44',
                    }}
                    percent={Math.round((progressInfo.percentageCompleted + Number.EPSILON) * 100) / 100}
                    status="active"
                />
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn"
                    data-toggle="collapse"
                    data-target="#components-card"
                    aria-controls="components-card"
                    onClick={onComponentStatus}
                    style={{
                        border: "0px",
                        color: "#FFFFFF",
                        backgroundColor: "#9296ff"
                    }}
                    >
                    <i
                        className={
                        componentStatus
                            ? "fas fa-angle-double-up"
                            : "fas fa-angle-double-down"
                        }
                    />
                </Button>
                <div className="row" style={{
                        width: "100%"
                    }}>
                    <div className="col-md-12">
                        <div className="collapse" id="components-card">
                            <p style={{ margin: "0px" }}>No of Scenario Groups Generated : {progressInfo.completed_scenario_group}</p>
                            <p style={{ margin: "0px" }}>Total No of Scenario Groups : {progressInfo.total_scenario_group}</p>   
                        </div>
                    </div>
                </div>
            </ModalFooter>
        </Modal>
    ): null
}

ProgressBar.propTypes = {
    popup: PropTypes.bool,
    loading: PropTypes.func,
};


export default ProgressBar;